import StyledLoader from "./styles/StyledLoader.js";
export default StyledLoader;
